import _ from 'lodash';

declare global {
  interface Window {
    rioCopyStringToClipboard: (value: string) => void;
  }
}

// This is just for the local dev environment where Google Analytics isn't
// imported. We need to at least set it to null here so that other code
// know it is defined.
if (!(window as any).gtag) {
  (window as any).gtag = null;
}

//
// trackOutboundLink
//
(window as any).trackOutboundLink = (url: string, as?: string) => {
  RIO_TRACK_EVENT('event', 'click', {
    link_url: url,
    link_domain: new URL(url).hostname,
    outbound: 'true'
  });

  (window as any).open(url, '_blank');
};

//
// rioScrollToAnchor
//
(window as any).rioScrollToAnchor = (anchor: string, topOffset?: number) => {
  const element = document.getElementById(anchor);
  if (element) {
    // change hash without triggering hashchange
    (window as any).history.replaceState(null, null, (document as any).location.pathname + '#' + anchor);

    if ((window as any).scrollIntoView) {
      (window as any).scrollIntoView(element, {
        align: {
          topOffset: typeof topOffset === 'number' ? topOffset : 60,
          top: 0
        }
      });
    }
  }
};

//
// rioCopyInputToClipboard
//
(window as any).rioCopyInputToClipboard = (id: string) => {
  const element = document.getElementById(id) as any;
  if (element && element.select) {
    element.select();
    document.execCommand('copy');
  }
};

//
// rioCopyStringToClipboard
//
(window as any).rioCopyStringToClipboard = (value: string) => {
  if (navigator?.clipboard) {
    navigator.clipboard.writeText(value);
  }
};

//
// rioSelectInput
//
(window as any).rioSelectInput = (id: string) => {
  const element = document.getElementById(id) as any;
  if (element && element.select) {
    element.select();
  }
};

//
// rioShowTab
//
(window as any).rioShowTab = (tabSetId: string, tabId: string) => {
  const tabSet = document.getElementById(tabSetId) as any;
  const tab = document.getElementById(tabId) as any;
  if (!tabSet || !tab) {
    return;
  }

  tabSet.querySelectorAll('.slds-show').forEach((e: any) => e.classList.replace('slds-show', 'slds-hide'));
  tabSet.querySelectorAll('.slds-active').forEach((e: any) => e.classList.remove('slds-active'));
  tabSet.querySelectorAll(`[for="${tabId}"]`).forEach((e: any) => e.classList.add('slds-active'));
  tab.classList.replace('slds-hide', 'slds-show');
};

//
// rioOpenCenteredPopup
//
// credit from: https://stackoverflow.com/a/16861050
(window as any).rioOpenCenteredPopup = (url: string, title: string, w: number, h: number) => {
  // Fixes dual-screen position                         Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document!.documentElement!.clientWidth
      ? document!.documentElement!.clientWidth
      : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document!.documentElement!.clientHeight
      ? document!.documentElement!.clientHeight
      : screen.height;

  const left = width / 2 - w / 2 + dualScreenLeft;
  const top = height / 2 - h / 2 + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    'resizable=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left
  );

  // Puts focus on the newWindow
  newWindow?.focus();
};

(window as any).rioRefreshWowheadTooltips = () => {
  // console.log('*** Refreshing Wowhead Tooltips');
  try {
    if ((window as any).$WowheadPower && (window as any).WH && (window as any).WH.getDataEnv) {
      (window as any).$WowheadPower.refreshLinks(true);
    }
  } catch (err) {
    console.error('Wowhead tooltip error', err);
  }
};

(window as any).rioDebouncedRefreshWowheadTooltips = _.debounce((window as any).rioRefreshWowheadTooltips, 33);

(window as any).RIO_TRACK_EVENT = (...args: any[]) => {
  const { gtag } = window as any;
  // if (typeof console.info === 'function') {
  //   console.info('[RIO_TRACK_EVENT]', ...args);
  // }
  if (typeof gtag === 'function') {
    gtag(...args);
  }
};
